export default __webpack_public_path__ + "static/media/calender.4a8ef0a9.svg";